
import VueModal from './Modal.vue'

const Modal = {
    install(Vue, options) {
        const modal = Vue.extend(VueModal)
        const Profile = new modal({
            el: document.createElement('div')
        })

        document.body.appendChild(Profile.$el);
        const myModal = {
            confirm(msg, callback) {
                Profile.type = 0;
                Profile.msg = msg;
                Profile.callback = callback;
            },
            succ(msg, title) {
                Profile.type = 1;
                Profile.msg = msg;
                Profile.title = title;
            },
            fail(msg, title) {
                Profile.type = 2;
                Profile.msg = msg;
                Profile.title = title;
            },
            close() {
                Profile.type = -1;
            }
            
        }
        Vue.prototype.$modal = myModal;
    }
}

// const defaultOptions = {
//     type: -1,
//     msg: '',
//     title: '',
//     callback: null
// };
// let queue = [];

// function isInDocument(element) {
//     return document.body.contains(element);
// }

// function createInstance() {

//     queue = queue.filter((item) => isInDocument(item.$el));

//     if (!queue.length || multiple) {
//         const modal = new (Vue.extend(VueModal))({
//             el: document.createElement('div'),
//         });

//         queue.push(modal);
//     }

//     return queue[queue.length - 1];
// }

// function Modal(options = {}) {
//     const modal = createInstance();
//     options = {
//         ...defaultOptions,
//         ...options,
//     };

//     options.clear = () => {
//         modal.$on('closed', () => {
//             queue = queue.filter((item) => item !== modal);
//             modal.$destroy();
//         });

//     };

//     Object.assign(modal, options);
//     return modal;
// }

// const createMethod = (t) => (options) =>
//     Modal({
//         type,
//         ...options,
//     });

// ['success', 'fail'].forEach((method) => {
//     let type = -1;
//     if (method == 'success') {
//         type = 1;
//     }
//     else {
//         type = 2;
//     }
//     Modal[type] = createMethod(type);
// });

// Modal.clear = (all) => {
//     if (queue.length) {
//         if (all) {
//             queue.forEach((modal) => {
//                 modal.clear();
//             });
//             queue = [];
//         } else {
//             queue.shift().clear();
//         }
//     }
// };

// Modal.install = () => {
//     Vue.use(VueModal);
// };



// Vue.prototype.$modal = Modal;

export default Modal









